import React, { createContext, useState, useEffect } from 'react';

export  const ThemeContext = createContext();

export  const ThemeProvider = ({ children }) => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [loggedIn,setLoggedIn]=useState(false);

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
      document.body.style.backgroundColor = '#0f172a';
    } else {
      document.documentElement.classList.remove('dark');
      document.body.style.backgroundColor = '#ffffff';
    }
  }, [isDarkMode]);

  return (
    <ThemeContext.Provider value={{ isDarkMode, setIsDarkMode,loggedIn,setLoggedIn}}>
      {children}
    </ThemeContext.Provider>
  );
};